import { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

const SCOPE = ["الحساب وبيانات الدخول (ويشمل أي حساب مكرر بنفس البريد)", "المحفظة والرصيد والمنح وهدية الترحيب", "المشاريع والاستراتيجيات والحملات والأهداف",
  "المحتوى المولّد وملفات الصور والفيديو", "ربط حسابات التواصل والنشر المجدول", "طلبات الدفع والإحالات وسجلات الاستخدام"];

/** تأكيد حذف نهائي لعميل: يوضّح أن الحذف لا رجعة فيه وما الذي يُحذف، ويتطلب كتابة البريد. */
export const DeleteUserDialog = ({ target, busy, onConfirm, onClose }) => {
  const [typed, setTyped] = useState("");
  const ok = target && typed.trim().toLowerCase() === (target.email || "").toLowerCase();
  return (
    <AlertDialog open={!!target} onOpenChange={(o) => !o && !busy && onClose()}>
      <AlertDialogContent dir="rtl" className="max-w-md" data-testid="delete-user-dialog">
        <AlertDialogHeader className="text-start">
          <AlertDialogTitle className="flex items-center gap-2 text-destructive"><AlertTriangle className="w-5 h-5" /> حذف نهائي لا يمكن التراجع عنه</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm text-start">
              <p>سيُحذف العميل <b dir="ltr">{target?.email}</b> ({target?.projects || 0} مشروع) حذفًا <b>نهائيًا وفوريًا</b> من قاعدة البيانات وملفات التخزين، ولا توجد نسخة احتياطية قابلة للاستعادة لهذا الحساب.</p>
              <ul className="list-disc pr-5 space-y-0.5 text-muted-foreground">{SCOPE.map((s) => <li key={s}>{s}</li>)}</ul>
              <p className="text-xs text-muted-foreground">تُحفظ الفواتير وسجلات البيع مجهّلة الهوية فقط للالتزام النظامي بحفظ السجلات المالية، ولا تُمكّن من استعادة الحساب. إن سجّل العميل مجددًا بنفس البريد يُعامل كعميل جديد تمامًا.</p>
              <label className="block text-xs font-semibold">اكتب البريد للتأكيد:
                <input dir="ltr" value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={target?.email} data-testid="delete-user-confirm-input"
                  className="mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm" />
              </label>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel disabled={busy} data-testid="delete-user-cancel-btn">إلغاء</AlertDialogCancel>
          <Button variant="destructive" disabled={!ok || busy} onClick={onConfirm} data-testid="delete-user-confirm-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null} احذف نهائيًا
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
